import Check from "@mui/icons-material/Check";
import Hd from "@mui/icons-material/Hd";
import Tune from "@mui/icons-material/Tune";
import {
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  ListItemText,
  Box,
  useMediaQuery,
} from "@mui/material";
import { useState } from "react";
import { Level } from "hls.js";

interface QualitySettingsProps {
  levels: Level[];
  currentLevel: number;
  changeQuality: (level: number) => void;
}

export default function QualitySettings({
  levels,
  currentLevel,
  changeQuality,
}: QualitySettingsProps) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const isAutoSelected = currentLevel === -1;
  const selectedHeight = currentLevel >= 0 ? levels[currentLevel]?.height : null;
  const isFullHdSelected = selectedHeight === 1080;
  const isMobile = useMediaQuery("(max-width: 600px)");

  const open = Boolean(anchorEl);

  const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleQuality = (level: number) => {
    changeQuality(level);
    handleClose();
  };
  const fullscreenRoot = anchorEl?.ownerDocument?.fullscreenElement ?? null;

  return (
    <>
     <Box sx={{
          backgroundColor: "rgb(20 20 30 / 0.7)",
          "&:hover": { backgroundColor: "rgba(50 50 70 / .7)" },

    }}>
      <IconButton
        size="small"
        onClick={handleOpen}
        sx={{
          position: "relative",
          color: "white",
          mb:  -5,
        //   backgroundColor: "rgba(0, 0, 0, 0.7)",
        //   "&:hover": { backgroundColor: "rgba(255,255,255,0.2)" },
        }}
      >
        <Tune fontSize={isMobile ? "small" : "medium"} />
        {isFullHdSelected && (
          <Hd fontSize="large"
            sx={{
              position: "absolute",
              p:0,
              zIndex: 2,
              top: -3,
              right: -3,
              fontSize: 18,
              color: "#ffff",
              backgroundColor: "rgba(255, 0, 0, 0.7)",
            //   filter: "drop-shadow(0 0 2px rgba(0,0,0,0.85))",
            }}
          />
        )}
      </IconButton>
    </Box>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        disablePortal={Boolean(fullscreenRoot)}
        container={fullscreenRoot ?? undefined}
        marginThreshold={12}
        slotProps={{
          paper: {
            sx: {
              zIndex: 9999,
              backgroundColor: "rgba(20, 20, 28, 0.94)",
              color: "#fff",
              border: "1px solid rgba(255,255,255,0.12)",
              minWidth: 150,
              maxWidth: "calc(100vw - 24px)",
              maxHeight: "min(50vh, 320px)",
              overflowY: "auto",
            },
          },
        }}
        MenuListProps={{
          dense: true,
        }}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
      >
        <MenuItem
          onClick={() => handleQuality(-1)}
          selected={isAutoSelected}
          sx={{
            py: 1,
            "&.Mui-selected": { backgroundColor: "rgba(255,255,255,0.12)" },
            "&.Mui-selected:hover": { backgroundColor: "rgba(255,255,255,0.2)" },
          }}
        >
          <ListItemIcon sx={{ minWidth: 28, color: "#fff" }}>
            {isAutoSelected ? <Check fontSize="small" /> : null}
          </ListItemIcon>
          <ListItemText>Auto</ListItemText>
        </MenuItem>

        {levels.map((level: Level, index: number) => {
          const isSelected = currentLevel === index;
          return (
          <MenuItem
            key={index}
            onClick={() => handleQuality(index)}
            selected={isSelected}
            sx={{
              py: 1,
              "&.Mui-selected": { backgroundColor: "rgba(255,255,255,0.12)" },
              "&.Mui-selected:hover": { backgroundColor: "rgba(255,255,255,0.2)" },
            }}
          >
            <ListItemIcon sx={{ minWidth: 28, color: "#fff" }}>
              {isSelected ? <Check fontSize="small" /> : null}
            </ListItemIcon>
            <ListItemText>
              {level.height}p
            </ListItemText>
          </MenuItem>
          );
        })}
      </Menu>
    </>
  );
}
